module.exports = __webpack_public_path__ + "static/media/employee.b6c2fef7.png";